import { useEffect, useState } from 'react';
import QuestionDetail from './QuestionDetail';
import {
  useGetQuestionByIdMutation
} from '../../../features/authentication/assignApiSlice';
import { 
  useGetPublicQuestionDetailsByIdMutation,
  useGetPreviewAssignmentInfoMutation
} from '../../../features/authentication/assignmentApislice';
import Modal from '../../../components/Modal';
import PropTypes from 'prop-types';
import QuestionPreviewTypes from '../../../enums/questionPreviewTypes';
import {
  useGetPublicAssignmentInfoMutation
} from '../../../features/authentication/publicAssignmentApiSlice';
import { useGetQuestionPreviewMutation } from '../../../features/authentication/qSetApiSlice';
import CustomToast from '../../../components/Toast';

function QuestionPreviewModal ({isOpen, onClose, questionId, assignmentId, isPublicAssignment, isSetPreview, questionNo, qSetId}){
  const [showAssignmentPreviewModal, setShowAssignmentPreviewModal] = useState(false);
  const [questionDetails, setQuestionDetails] = useState(null);
  const [getQuestionById] = useGetQuestionByIdMutation();
  const [getPublicQuestionById] = useGetPublicQuestionDetailsByIdMutation();
  const [isLoading, setIsLoading] = useState(false);
  const [assignmentDetails, setAssignmentDetails] = useState(null);
  const [getPreviewAssignmentInfo] = useGetPreviewAssignmentInfoMutation();
  const [getPublicAssignmentInfo] = useGetPublicAssignmentInfoMutation();
  const [getQuestionPreview] = useGetQuestionPreviewMutation();

  useEffect(() => { 
    if(isOpen)
    {
      setQuestionDetails(null);
      
      if(!isSetPreview)
      {
        questionDetailsModalHandler();
        assignmentDetailsHandler();
      }
      else
        handleQSetQuestionDetails();
    }
  }, [isOpen]);

  const handleQSetQuestionDetails = async () => {
    setIsLoading(true);
    try{
      let options = {
        setId: qSetId,
        questionNo: questionNo
      };
      let response = await getQuestionPreview(options);
      if (response.error)
        CustomToast(response.error.data.error, 'error');
      else {
        setShowAssignmentPreviewModal(!showAssignmentPreviewModal);
        setQuestionDetails(response.data);
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };

  const questionDetailsModalHandler= async () => {
    setIsLoading(true);
    const options = {
      questionId: questionId,
      assignmentId: assignmentId
    };
    try {   
      let response ={}; 
      if(isPublicAssignment)     
        response = await getPublicQuestionById(options).unwrap();
      else
        response = await getQuestionById(options).unwrap();
      setShowAssignmentPreviewModal(!showAssignmentPreviewModal);
      setQuestionDetails(response);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const assignmentDetailsHandler = async () => {
    const option = { assignmentId: assignmentId };
    try {
      if(isPublicAssignment)
      {
        const response = await getPublicAssignmentInfo(option).unwrap();
        setAssignmentDetails(response);
      }
      else {
        const response = await getPreviewAssignmentInfo(option).unwrap();
        setAssignmentDetails(response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return(
    <Modal
      titleName={'Question'}
      isOpen={isOpen}
      onClose={() => onClose(false)}
      contentWidth="100%">

      <QuestionDetail
        isLoading={isLoading}
        questionDetails={questionDetails}
        assignmentId={assignmentId}
        type={QuestionPreviewTypes.questionPreview}
        assignmentDetails={assignmentDetails}
        isPublicAssignment={isPublicAssignment}
        isFromQset={isSetPreview}
      />
    </Modal>
  );
}

QuestionPreviewModal.propTypes =
{
  title : PropTypes.string.isRequired,
  isOpen : PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  questionId : PropTypes.number.isRequired,
  assignmentId : PropTypes.number.isRequired,
  isPublicAssignment : PropTypes.bool.isRequired,
  isSetPreview: PropTypes.bool,
  questionNo: PropTypes.number,
  qSetId: PropTypes.number
};
export default QuestionPreviewModal;